import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "csharp",
  extensions: [".cs", ".csx", ".cake"],
  aliases: ["C#", "csharp"],
  loader: () => import('./csharp.js')
});
